import { Injectable, ViewContainerRef, Compiler, NgModule } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

import { CacheService } from '../core/cache.service';
import { ApiService } from '../core/api.service';
import { AuthService } from '../core/auth.service';
import { Mappings } from '../../shared/mapping';
import { HttpParam } from "./../../models/core/http-param";
import { CurrencyService } from "../cms/currency.service";
import { LanguageService } from '../cms/language.service';

@Injectable()
export class SearchService {
  constructor
    (
    public _api: ApiService,
    public _cache: CacheService,
    public currencyService: CurrencyService,
    private mappings: Mappings,
    private authService: AuthService,
    private languageService: LanguageService
    ) {
  }

  public query: string;
  public base64EncodedValue: string;
  public queryText: string = "";

  getCategoriesAndProducts(query, startRow, endRow) {
    let lang = this.languageService.getLongLang();

    let url = this.mappings.Web_Api_Get_Product_And_Categories
      .replace('{startRowIndex}', startRow)
      .replace('{maxRows}', endRow)
      .replace('{lang}', lang)
      .replace('{query}', query);
    let key = url;

    return this._api.get(url);
  }

  getQueryValue() {
    var response = this.query;

    return response;
  }

  setQueryValue(newQuery: string) {
    this.query = newQuery;
  }

  setQueryPlainTextValue(newQuery: string) {
    this.queryText = newQuery;
  }

  getQueryPlainTextValue() {
    var response = this.queryText;

    return response;
  }

}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/inventory/search.service.ts